import httpClient from './httpClient';
const supportBusiness = {
    getList() {
        return httpClient.get(`/api/business-supports`);
    }
}

export default supportBusiness;